export const fetchDocument = async (doc, setDocuments) => {
  // console.log("=========1===legal document==========", doc);
  try {
    const response = await fetch(process.env.REACT_APP_BASE_URL + doc, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
        // Other headers if required
      },
    });

    // Check if the request was successful
    if (!response.ok) {
      throw new Error("Failed to fetch image");
    }

    // Convert the response to a blob
    const blob = await response.blob();

    // Create a URL for the blob and set it as the image source
    const imageUrl = URL.createObjectURL(blob);
    // console.log("============legal document==========", imageUrl);
    setDocuments(imageUrl);
  } catch (error) {
    console.error("===Error fetching image:", error);
  }
};

export const fetchDriverImage = async (imageFile, setDriverImage) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_BASE_URL + "/uploads/drivers/images/" + imageFile,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      }
    );

    // Check if the request was successful
    if (!response.ok) {
      throw new Error("Failed to fetch image");
    }

    // Convert the response to a blob
    const blob = await response.blob();

    // Create a URL for the blob and set it as the image source
    const imageUrl = URL.createObjectURL(blob);
    setDriverImage(imageUrl);
  } catch (error) {
    console.error("Error fetching image:", error);
  }
};

export const fetchVehicleImages = async (vehiclesData, setVehicleImage) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_BASE_URL + vehiclesData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      }
    );

    // Check if the request was successful
    // if (!response.ok) {
    //   throw new Error("Failed to fetch image", response);
    // }

    // Convert the response to a blob
    const blob = await response.blob();

    // Create a URL for the blob and set it as the image source
    const imageUrl = URL.createObjectURL(blob);

    setVehicleImage(imageUrl);
  } catch (error) {
    console.error("Error fetching image:", error);
  }
};

export const fetchPassengerImage = async (imageF, setPassengerImage) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_BASE_URL + "/uploads/passengers/images/" + imageF,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      }
    );
    const blob = await response.blob();
    const imageUrl = URL.createObjectURL(blob);

    setPassengerImage(imageUrl);
  } catch (error) {
    console.error("Error fetching image:", error);
  }
};

export const fetchDocuments = async (imageF, setPassengerImage) => {
  try {
    const response = await fetch(
      process.env.REACT_APP_BASE_URL + "/uploads/passengers/images/" + imageF,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      }
    );
    const blob = await response.blob();
    const imageUrl = URL.createObjectURL(blob);

    setPassengerImage(imageUrl);
  } catch (error) {
    console.error("Error fetching image:", error);
  }
};
